import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { TextField, TextButton } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export default function BillingItemNote(props) {
    const { t: texts } = useLocaleKeys('components.billingItemNote');
    const { control, getValues } = useFormContext();
    const { testId } = props;
    const [isAddingNote, setIsAddingNote] = useState(false);
    const [initialNote] = useState(getValues(props.name));
    return isAddingNote || !!initialNote ? /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: props.name,
        rules: richTextValidation('Note'),
        render: (param)=>{
            let { field: { value, ref, onChange, onBlur }, fieldState: { isTouched, isDirty, error } } = param;
            return /*#__PURE__*/ _jsx(TextField, {
                collapseHelperText: false,
                multiline: true,
                width: 500,
                label: texts.label(),
                minRows: 3,
                maxRows: 3,
                testId: testId,
                error: isTouched && !!error,
                helperText: isTouched && error && error.message,
                value: value,
                inputRef: (element)=>{
                    ref(element);
                    if (element && initialNote && !isDirty) {
                        // Set the cursor to the end of the note
                        element.setSelectionRange(initialNote.length, initialNote.length);
                    }
                },
                onChange: onChange,
                onBlur: onBlur
            });
        }
    }) : /*#__PURE__*/ _jsx(TextButton, {
        underline: "none",
        testId: testId && "".concat(testId, "-add-note"),
        onClick: ()=>setIsAddingNote(true),
        children: "+ Add Note"
    });
}
